import { render, staticRenderFns } from "./NameText.vue?vue&type=template&id=28497434&"
import script from "./NameText.vue?vue&type=script&lang=js&"
export * from "./NameText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports